import { render, staticRenderFns } from "./OnboardingFormLayout.vue?vue&type=template&id=c9b32048&scoped=true"
import script from "./OnboardingFormLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnboardingFormLayout.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OnboardingFormLayout.vue?vue&type=style&index=0&id=c9b32048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b32048",
  null
  
)

export default component.exports